import { createFileRoute } from '@tanstack/react-router'

import { fetchMonthlyTourReportInvoice } from '@/features/monthly-tour-reports/api'
import { fetchMonthlyTourReportInvoiceDetails } from '@/features/monthly-tour-reports/api'

export const Route = createFileRoute(
  '/_protected/$tenantKey/_performance_managements/monthly-tour-reports/$monthlyTourReportId/invoice/'
)({
  loader: async ({
    abortController,
    params: { tenantKey, monthlyTourReportId },
    context: { auth }
  }) => {
    const monthlyTourReportInvoice = await fetchMonthlyTourReportInvoice(
      {
        tenantKey,
        monthlyTourReportId
      },
      abortController.signal
    )
    const monthlyTourReportInvoiceDetails =
      await fetchMonthlyTourReportInvoiceDetails(
        {
          tenantKey,
          monthlyTourReportId
        },
        abortController.signal
      )
    return {
      authUser: auth.user,
      monthlyTourReportInvoice,
      monthlyTourReportInvoiceDetails
    }
  }
})
